module.exports = __webpack_public_path__ + "img/centered-logo-nav-honda.89dcb483.png";